import dayjs from 'dayjs'

export const timeFormatter = (value: string) => {
  return dayjs(value)?.format('HH:mm') ?? ''
}
